import { isTeaserBet } from "../../../common";
import { getSelectionTitleProps, getSelectionTitleTeaserProps, getSelectionStatusLabelProps, getEventDetailsSingleProps, getMarketNameProps, isSelectionNotFixture } from "../../selection";
export const getSelectionDetailsProps = (bet, selection, state) => {
    return {
        isOutright: isSelectionNotFixture(selection),
        selectionTitle: isTeaserBet(bet.type)
            ? getSelectionTitleTeaserProps(selection)
            : getSelectionTitleProps(bet, selection, state),
        marketName: getMarketNameProps(selection),
        selectionStatusLabel: getSelectionStatusLabelProps(selection, state),
        eventDetails: getEventDetailsSingleProps(bet.type, selection, state)
    };
};
//# sourceMappingURL=getSelectionDetailsProps.js.map